import { ViewModel, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { IWarehouse } from "../iWarehouse";
import { WarehouseEditorView } from "./warehouseEditor-view"
import { WarehouseSelector } from "../warehouseSelector";

export class WarehouseEditorViewModel extends ViewModel implements IWarehouse, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater, isUpdate: boolean) {
        super(parentViewModel);
        this.districtSelector = new DistrictSelector(this);
        this.districtSelector.onSelectionChanged = x => this.districtId = x.id;
        this.parentSelector = new WarehouseSelector(this);
        this.parentSelector.onSelectionChanged = x => this.parentId = x.id;
        this.isUpdate = isUpdate;
        this._updater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new WarehouseEditorView();
    }
    public getTypeId(): string {
        return "VM-339F8E06-7C42-4E7E-A436-4AEC69CCAB1F"
    }


    cloneTo(warehouse: IWarehouse) {
        warehouse.id = this.id;
        warehouse.name = this.name;
        warehouse.districtId = this.districtSelector.selectedItem.id;
        warehouse.districtName = this.districtSelector.selectedItem.title;
        warehouse.parentId = this.parentSelector.selectedItem.id;
        warehouse.parentName = this.parentSelector.selectedItem.title;
        warehouse.hasParent = this.hasParent;
    }

    closePopup(result: any) {
    }

    private _updater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set districtId(v: string) {
        this._districtId = v;
        this.districtSelector.selectById(v);
    } public get districtId(): string { return this._districtId; } private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set districtSelector(v: DistrictSelector) { this._districtSelector = v; } public get districtSelector(): DistrictSelector { return this._districtSelector; } private _districtSelector: DistrictSelector;
    public set isUpdate(v: boolean) { this._isUpdate = v; } public get isUpdate(): boolean { return this._isUpdate; } private _isUpdate: boolean;
    public set parentSelector(v: WarehouseSelector) { this._parentSelector = v; } public get parentSelector(): WarehouseSelector { return this._parentSelector; } private _parentSelector: WarehouseSelector;
    public set parentId(v: string) {
        this._warehouseId = v;
        this.parentSelector.selectById(v);
    } public get parentId(): string { return this._warehouseId; } private _warehouseId: string;
    public set parentName(v: string) {
        this._parentName = v;
    } public get parentName(): string { return this._parentName; } private _parentName: string;
    public set hasParent(v: boolean) { this._hasParent = v; } public get hasParent(): boolean { return this._hasParent; } private _hasParent: boolean;

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), translate("warehouseEditor-viewModel.warehouseError", {}));
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess(translate("warehouseEditor-viewModel.successfullyRegistered", {}), translate("warehouseEditor-viewModel.successfulRegistration", {}));
                this.closePopup(this);
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(translate("warehouseEditor-viewModel.warehouseError", {}), translate("warehouseEditor-viewModel.error", {}));
            } finally {
                this.isLoading = false;
            }
        }
    }


    verify(): string[] {
        let result: string[] = [];
        if (this.isUpdate) {
            if (stringIsNullOrEmpty(this.name)) {
                result.push(translate("warehouseEditor-viewModel.nameError", {}));
            }
        } else {
            if (stringIsNullOrEmpty(this.name)) {
                result.push(translate("warehouseEditor-viewModel.nameError", {}));
            }
            if (this.districtSelector.selectedItem == null) {
                result.push(translate("warehouseEditor-viewModel.branchError", {}));
            }
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(warehouse: IWarehouse): Promise<any>;
}

export class WarehouseInserter implements IServerUpdater {
    async execute(warehouse: IWarehouse): Promise<any> {
        try {

            let result = await ServerConnection.callServer('/Complex/InventoryManipulationServices/CreateWarehouse', {
                Name: warehouse.name,
                DistrictId: warehouse.districtId,
                ParentId: warehouse.parentId
            });
            if (result.IsSuccessful == false) {
                throw "Error Saving Warheouse";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }
}

export class WarehouseUpdater implements IServerUpdater {
    async execute(warehouse: IWarehouse): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/InventoryManipulationServices/UpdateWarehouse', {
                Id: warehouse.id,
                NewName: warehouse.name,
                ParentId: warehouse.hasParent == false ? null : warehouse.parentId
            });
            if (result.IsSuccessful == false) {
                throw "Error Saving Warehouse";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }
}
